import React from 'react';
import error from '@/assets/overview/error.svg';
import $i18n from '../../../i18n';

import './index.less';

const TestError: React.FC = () => {
  return (
    <div className="test-error-container">
      <div className="error-logo">
        <img src={error} alt="" />
      </div>
      <div className="error-msg">
        <div className="error-title">
          {$i18n.get({
            id: 'aopf.pages.test.error.failed',
            dm: 'miniapp无法正确启动',
          })}
        </div>
        <div className="error-describe">
          {$i18n.get({
            id: 'aopf.pages.test.error.reason',
            dm: '出现这种情况的原因可能是您正在使用',
          })}
          <span className="error-bold">
            {$i18n.get({
              id: 'aopf.pages.test.error.mismatched',
              dm: '不匹配的应用',
            })}
          </span>
          {$i18n.get({
            id: 'aopf.pages.test.error.scan.code',
            dm: '扫描二维码',
          })}
        </div>
        <div className="error-describe">
          {$i18n.get({
            id: 'aopf.pages.miniapp.version.tabs.release.code.des',
            dm: '请使用',
          })}
          <span className="error-bold">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.tabs.release.code.target',
              dm: '目标应用程序',
            })}
          </span>
          {$i18n.get({
            id: 'aopf.pages.miniapp.version.tabs.release.code.des.two',
            dm: '扫描此二维码，以预览和测试您的小程序。',
          })}
        </div>
      </div>
    </div>
  );
};

export default TestError;
